import { TaxModalFormComponent } from "./../features/user/tax-modal-form/tax-modal-form.component";
import { InputModalComponent } from "./input-modal/input-modal.component";
import { StartupModalComponent } from "./startup-modal.component";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { BuyComponent } from "./../features/buy-sell/buy-modals/buy.component";
import { ChangePasswordOnboardingComponent } from "./../auth/change-password-onboarding/change-password-onboarding.component";
import { ModelPortfolioSubscriptionsFormComponent } from "../features/model-portfolios/mp-subscriptions/mp-subscriptions-form/mp-subscriptions-form.component";
import { ConfirmationDialogComponent } from "./../shared/confirmation-dialog/confirmation-dialog.component";
import { ModelPortfolioPositionFormComponent } from "../features/model-portfolios/mpoverview/mp-positions/mp-position-form/mp-position-form.component";
import { ModelPortfolioFormComponent } from "../features/model-portfolios/mpoverview/mp-form/model-portfolio-form.component";
import { UtilsModule } from "./../../utils/utils.module";
import { AdminisSharedModule } from "../shared/adminis-shared.module";
import { DepositComponent } from "../features/widgets/wallet/deposit/deposit.component";
import { WithdrawComponent } from "../features/widgets/wallet/withdraw/withdraw.component";
import { SellComponent } from "../features/buy-sell/sell-modals/sell.component";
import { SelectionComponent } from "../features/buy-sell/selection/selection.component";
import { CancelOrderConfirmationComponent } from "../features/buy-sell/cancel-order-confirmation/cancel-order-confirmation.component";
import { ApproveOrderConfirmationComponent } from "../features/buy-sell/approve-order-confirmation/approve-order-confirmation.component";
import { SaveFailedComponent } from "../features/registration/modals/save-failed/save-failed.component";
import { TransferComponent } from "../features/widgets/wallet/transfer/transfer.component";
import { WithdrawalReduceDriftExportComponent } from "../features/widgets/wallet/withdrawal-reduce-drift-export/withdrawal-reduce-drift-export.component";
import { AddNotesComponent } from "../features/model-portfolios/add-notes/add-notes.component";
import { DepositModalComponent } from "../features/widgets/wallet/deposit/modal/deposit-modal.component";
import {
    DepositMultipleBankAccountNumberComponent
} from "../features/widgets/wallet/deposit/multiple-deposit-bank-account-number.component";
import { DepositDrilldownModalComponent } from "../features/widgets/wallet/deposit/modal/deposit-drilldown-modal.component";
import { CompulsoryDocumentDownloadComponent } from "../shared/compulsory-document-download/compulsory-document-download.component";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        AdminisSharedModule,
        UtilsModule,
        DepositMultipleBankAccountNumberComponent,
        CompulsoryDocumentDownloadComponent
    ],
    declarations: [
        TaxModalFormComponent,
        StartupModalComponent,
        ChangePasswordOnboardingComponent,
        ModelPortfolioFormComponent,
        AddNotesComponent,
        ModelPortfolioPositionFormComponent,
        ConfirmationDialogComponent,
        ModelPortfolioSubscriptionsFormComponent,
        DepositComponent,
        DepositDrilldownModalComponent,
        DepositModalComponent,
        WithdrawComponent,
        BuyComponent,
        SellComponent,
        SelectionComponent,
        SaveFailedComponent,
        CancelOrderConfirmationComponent,
        ApproveOrderConfirmationComponent,
        InputModalComponent,
        TransferComponent,
        WithdrawalReduceDriftExportComponent,
    ],
    exports: [StartupModalComponent],
})
export class ModalModule {}